<script>
export default {
  props: {
    onPreviousReport: {
      type: Function,
      required: true,
    },
    previousDisabled: {
      type: Boolean,
      default: false,
    },
    onNextReport: {
      type: Function,
      required: true,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
